
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
directives: {
TransferDom
},
name: "register-begin",
data(){
return{
telephoneConfirm:false
}
},
methods:{
changeStep(type){
this.$emit('next',type);
},
sendEmail(){
this.telephoneConfirm = true;
},
onCancel(){
this.telephoneConfirm = false;
},
onConfirm(e){
this.telephoneConfirm = false;
this.$loadingShow();
this.$get('api/before-login/active-check-phone?_allow_anonymous=true',{phone:e}).then((data) => {
this.$vux.toast.text('验证码发送成功');
let queryParam = {checkKey:data.checkKey,phone:data.phone};
this.$router.push({path:'/supplier/phone-valid',query:queryParam});
this.$loadingHide();
}).catch(()=>this.$loadingHide());
}
}
}



// WEBPACK FOOTER //
// ./src/page/supplier/register/register-begin.vue